module.exports = __webpack_public_path__ + "3293616ec0c605c7c2db25829a0a509e.woff";